import "bootstrap/dist/css/bootstrap.min.css";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa"
import { FaArrowAltCircleUp } from "react-icons/fa";
import { FaArrowAltCircleDown } from "react-icons/fa";
// import { TbReplaceFilled } from "react-icons/tb";
import { useFetchData } from "../helpers/FetchDataHelpers";
import { ListGroup, ListGroupItem, Form, FormSelect, Stack, Dropdown, Button } from "react-bootstrap";
import { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { UserContext } from "../context/UserContext";
import { toast } from "react-toastify";

export default function ScaleDetails(props) {

    const actions = {
        EDIT: 'EDIT',
        REMOVE: 'REMOVE',
        NO_ACTION: 'NO_ACTION'
    }

    const { scale, deploymentId, gondolaId, gateways, refetchGondolaInfo } = props;

    const [ongoingAction, setOngoingAction] = useState(actions.NO_ACTION);
    const [buttonsDisabled, setButtonsDisabled] = useState(false);

    const fetchData = useFetchData();
    const { userenv } = useContext(UserContext);

    const { register, handleSubmit, reset, setValue } = useForm()

    const onRemoveScale = () => {
        setButtonsDisabled(true);
        const removeScale = async () => {
            const baseUrl = `${import.meta.env.VITE_STORE_DEPLOYMENT_API_URL}/store-deployments/${userenv}/${deploymentId}`
            const url = baseUrl + `/gondolas/${gondolaId}/scales/${scale.scale_id}`;
            const { isResponseOK, errorMessage } = await fetchData(url, "DELETE");
            refetchGondolaInfo();
            if (!isResponseOK) {
                toast.error("Error: " + errorMessage);
            }
            setButtonsDisabled(false);
        };
        removeScale();
    };

    const onEditScale = (data) => {

        let newScaleInfo = {}
        newScaleInfo.scale_id = props.scale.scale_id
        newScaleInfo.scale_gateway_id = Number(data.new_gateway_id)
        newScaleInfo.shelf_id = data.shelf_id
        newScaleInfo.backend_id = props.scale.backend_id
        newScaleInfo.vertical_position = props.scale.vertical_position
        newScaleInfo.serial_number = props.scale.serial_number
        newScaleInfo.qa_check = props.scale.qa_check
        newScaleInfo.qa_state = props.scale.qa_state
        newScaleInfo.qa_comment = data.qa_comment

        const editScale = async () => {
            setButtonsDisabled(true);
            const baseUrl = `${import.meta.env.VITE_STORE_DEPLOYMENT_API_URL}/store-deployments/${userenv}/${deploymentId}`;
            const url = baseUrl + `/gondolas/${gondolaId}/gateways/${scale.scale_gateway_id}/scales`;
            const body = JSON.stringify(newScaleInfo);
            const { isResponseOK, errorMessage } = await fetchData(url, "PATCH", false, body);
            if (!isResponseOK) {
                toast.error("Error: " + errorMessage);
            }else{
                toast.success("Scale updated successfully!")
                setOngoingAction(actions.NO_ACTION);
                refetchGondolaInfo();
            }
            setButtonsDisabled(false);
        };
        editScale();
    };

    const onMoveScale = (isDirectionUp) => {
        const moveScale = async () => {
            setButtonsDisabled(true);
            const direction = isDirectionUp ? "move-up" : "move-down";
            const baseUrl = `${import.meta.env.VITE_STORE_DEPLOYMENT_API_URL}/store-deployments/${userenv}/${deploymentId}`
            const url = baseUrl + `/gondolas/${gondolaId}/gateways/${scale.scale_gateway_id}/scales/${scale.scale_id}/${direction}`;
            const { isResponseOK, errorMessage } = await fetchData(url, "PATCH");
            if (!isResponseOK) {
                toast.error("Error: " + errorMessage);
            } else {
                toast.success("Scale moved successfully");
                refetchGondolaInfo();
            }
            setButtonsDisabled(false);
        };
        moveScale();
    }

    const determineScaleGatewayBackendId = (scale_gateway_id) => {
        let gateway_backend_id = gateways.filter(gateway => gateway.scale_gateway_id === scale_gateway_id)[0].backend_id
        if (gateway_backend_id === null) {
            return scale_gateway_id
        } else {
            return gateway_backend_id
        }
    }

    return (
        <Stack gap={3} className="mt-4">
            <Stack direction="horizontal" gap={3} className="justify-content-between align-items-center">
                <h5 className="mb-0">Scale {scale.serial_number}</h5>
                <Dropdown>
                    <Dropdown.Toggle variant="secondary" size="sm" disabled={buttonsDisabled}>
                        Actions
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => { setOngoingAction(actions.EDIT) }}>
                            <FaEdit className="me-2" />
                            Edit
                        </Dropdown.Item>
                        {props.scale.vertical_position !== 1 &&
                            <Dropdown.Item onClick={() => { onMoveScale(false) }}>
                                <FaArrowAltCircleUp className="me-2" />
                                Move Up
                            </Dropdown.Item>}
                        {props.scale.vertical_position !== 9 &&
                            <Dropdown.Item onClick={() => { onMoveScale(true) }}>
                                <FaArrowAltCircleDown className="me-2" />
                                Move Down
                            </Dropdown.Item>}
                        <Dropdown.Item onClick={() => { setOngoingAction(actions.REMOVE) }}>
                            <FaTrash className="me-2" />
                            Remove
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Stack>


            {ongoingAction === actions.REMOVE &&
                <Stack gap={3} direction="horizontal" >
                    <span>
                        Remove Scale ?
                    </span>
                    <Button disabled={buttonsDisabled} className="flex-grow-1" variant="danger" size="sm" onClick={() => { setOngoingAction(actions.NO_ACTION); }}>
                        Cancel
                    </Button>
                    <Button disabled={buttonsDisabled} className="flex-grow-1" variant="success" size="sm" onClick={() => { onRemoveScale(); setOngoingAction(actions.NO_ACTION); }}>
                        Confirm
                    </Button>
                </Stack>
            }

            {ongoingAction === actions.EDIT &&
                <Form noValidate onSubmit={handleSubmit(onEditScale)}>
                    <div className="mb-3 fw-bold">
                        Edit Scale
                    </div>
                    <Form.Group controlId="form.EditScale">
                        {setValue("serial_number", scale.serial_number)}
                        {setValue("qa_check", scale.qa_check)}
                        {setValue("qa_state", scale.qa_state)}
                        {setValue("qa_comment", scale.qa_comment)}
                        {setValue("shelf_id", scale.shelf_id)}
                        Gateway:
                        <FormSelect className="mt-1 mb-3" defaultValue={scale.scale_gateway_id}
                            {...register("new_gateway_id")}>
                            {gateways.map((gateway, index) => (
                                <option key={index} value={gateway.scale_gateway_id}>
                                    {gateway.mac_address}
                                </option>
                            ))}
                        </FormSelect>
                        <Form.Label className="mt-3">QA Comment:</Form.Label> &nbsp;&nbsp;&nbsp;
                        <Form.Control as="textarea" {...register("qa_comment")} rows={3} />
                    </Form.Group>
                    <Stack gap={3} direction="horizontal" className="mt-3">
                        <Button disabled={buttonsDisabled}  className="flex-grow-1" size="sm" variant="danger" onClick={() => { reset(); setOngoingAction(actions.NO_ACTION); }}>
                            Cancel
                        </Button>
                        <Button  disabled={buttonsDisabled}  type="submit" className="flex-grow-1" size="sm" variant="primary">
                            Save
                        </Button>
                    </Stack>
                </Form>
            }

            {ongoingAction !== actions.EDIT &&
                <ListGroup>
                    <ListGroupItem>
                        Vertical Position: &nbsp; {scale.vertical_position}
                    </ListGroupItem>
                    <ListGroupItem>
                        Serial Number: &nbsp; {scale.serial_number}
                    </ListGroupItem>
                    <ListGroupItem>
                        Shelf Id: &nbsp; {scale.shelf_id}
                    </ListGroupItem>
                    <ListGroupItem>
                        Backend Id: &nbsp; {scale.backend_id}
                    </ListGroupItem>
                    <ListGroupItem>
                        QA Check: &nbsp; &nbsp;
                        <Form.Check inline disabled checked={scale.qa_check} type="checkbox" id="qa-check-switch" />
                    </ListGroupItem>
                    <ListGroupItem>
                        QA State: &nbsp; &nbsp;
                        <Form.Check inline disabled checked={scale.qa_state} type="checkbox" id="qa-state-switch" />
                    </ListGroupItem>
                    {scale.qa_factory_triangulation_average_error != null &&
                        <ListGroupItem>
                            QA Factory Triang. Avg Error: &nbsp; {scale.qa_factory_triangulation_average_error.toFixed(2)}
                        </ListGroupItem>
                    }
                    {scale.qa_factory_calibration_average_error != null &&
                        <ListGroupItem>
                            QA Factory Calib. Avg Error: &nbsp; {scale.qa_factory_calibration_average_error.toFixed(2)}%
                        </ListGroupItem>
                    }
                    {scale.qa_factory_last_date != null &&
                        <ListGroupItem>
                            QA Factory Last Date: &nbsp; {new Date(scale.qa_factory_last_date).toLocaleString()}
                        </ListGroupItem>
                    }
                    {scale.qa_store_triangulation_average_error != null &&
                        <ListGroupItem>
                            QA Store Triang. Avg Error: &nbsp; {scale.qa_store_triangulation_average_error.toFixed(2)}
                        </ListGroupItem>
                    }
                    {scale.qa_store_last_date != null &&
                        <ListGroupItem>
                            QA Store Last Date: &nbsp; {new Date(scale.qa_store_last_date).toLocaleString()}
                        </ListGroupItem>
                    }
                    {scale.qa_comment != null && scale.qa_comment !== "" &&
                        <ListGroupItem>
                            QA Comment: &nbsp; {scale.qa_comment}
                        </ListGroupItem>}
                    <ListGroupItem>
                        Gateway Id: &nbsp; {determineScaleGatewayBackendId(scale.scale_gateway_id)}
                    </ListGroupItem>
                </ListGroup>}

        </Stack>
    )
}
